import styled from 'styled-components';

import theme from '../../../styles/defaultTheme';

export const ContainerInput = styled.div`
    height: 44px;
    min-width: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    border-radius: 8px;
    outline: none;
    border: 1px solid ${(props) => props.theme.lightGrey40};
    background-color: ${(props) => props.theme.white};
    padding: 0 16px;
    font-size: ${theme.font.size16};
    transition: all 0.3s;
    flex: 1;
    box-shadow: none;

    .icon-container {
        display: flex;
        cursor: pointer;
        span {
            color: ${(props) => props.theme.orange};
            font-size: ${theme.font.size20};
        }
    }

    &.disabled {
        background-color: ${(props) => props.theme.grey10};
    }

    &.error {
        border: 1px solid ${(props) => props.theme.red};
        input::placeholder {
            color: ${(props) => props.theme.red};
        }
        span {
            color: ${(props) => props.theme.red};
        }
    }

    &.ant-picker-focused:not(.error),
    &:not(.error):not(.disabled):hover,
    &:not(.error):not(.disabled):focus-within {
        border: 1px solid ${(props) => props.theme.orange};
    }
`;

export const StyledInput = styled.input`
    display: flex;
    height: 44px;
    width: 100%;
    font-size: ${theme.font.size16};
    box-shadow: none;
    border: none;

    text-transform: uppercase;
    
    :focus-visible {
        outline: none;
    }
    
    ::placeholder {
        text-transform: none;
        color: ${(props) => props.theme.black};
        font-size: ${theme.font.size16};
        opacity: 0.7;
    }

    :disabled {
        background-color: transparent !important;
        ::placeholder{color: ${(props) => props.theme.lightGrey40};}
    }
`;

export const SpanError = styled.span`
    color: ${(props) => props.theme.red};
    font-size: ${theme.font.size12};
    margin-top: 4px;
    padding-left: 2px;
`;

export const ContainerTag = styled.div`
    margin-top: 24px;
    
    div {
        display: inline-flex;
        padding: 8px 16px;
        margin: 0 16px 8px 0;
        font-size: ${theme.font.size14};
        justify-content: center;
        align-items: center;
        background-color: ${(props) => props.theme.hoverOrangeLink};
        border-radius: 16px;

        span {
            color: ${(props) => props.theme.black} !important;
            padding-left: 16px;
            cursor: pointer;
        }
    }
`;
